import React from "react"
import { IRapportoControlloLite } from "../../generated";
import { GetTable } from "../../common/components/DataTable"
import DatesHelper from "../../common/datesHelper";
import { Link } from "react-router-dom";
import { links } from "../../routes";

const Table = GetTable<IRapportoControlloLite>();
export const RapportiControlloImpiantoTable: React.FC<{ rapporti: IRapportoControlloLite[], idCliente: number, onSelect: (r: IRapportoControlloLite) => void, onDelete: (r: IRapportoControlloLite) => void }> = ({ rapporti, onSelect, idCliente, onDelete }) => {
    return <Table
        data={rapporti}
        hideSummary
        keySelector={x => x.nrRapporto || "!!"}
    >
        <Table.Column
            header="Nr.Rapporto"
            template={x => x.nrRapporto}
        />
        <Table.Column
            header="Data Rapporto"
            template={x => DatesHelper.getReadableDateString(x.date)}
            orderBy={x => x.date.valueOf()}
        />
        <Table.Column
            header="Intervento"
            template={x => x.idIntervento && <Link target="_blank" to={links.interventoEdit(idCliente, x.idIntervento)}>{x.idIntervento}</Link> || <span />}
            orderable={false}
            groupable={false}
        />
        <Table.Column
            header="Operazioni"
            orderable={false}
            groupable={false}
            template={x =>
                <>
                    <button
                        type="button"
                        className="btn btn-sm btn-primary me-1"
                        onClick={() => onSelect(x)}>
                        Apri
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={() => onDelete(x)}>
                        <i className="fas fa-trash" />
                    </button>
                </>}
            orderBy={x => x.date.valueOf()}
        />
    </Table >
}